import { apiPrefix } from "@/config/config";
import { api, teacherAuthApi } from "../interceptor/api.interceptor";

class InstructorService {
  // Public route
  static async login(data) {
    return await api
      .post(`/${apiPrefix}/instructor/login`, data)
      .then((res) => res?.data?.data);
  }

  static async dashboardInfo() {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/dashboard`)
      .then((res) => res?.data?.data);
  }

  // Authenticated routes
  static async getProfile() {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/profile`)
      .then((res) => res?.data?.data);
  }

  static async updateProfile(data) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/update-profile`, data)
      .then((res) => res?.data?.data);
  }

  static async updatePassword(data) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/update-password`, data)
      .then((res) => res?.data?.data);
  }

  static async getAllInstructors(page) {
    return await api
      .get(`/${apiPrefix}/allInstuctors`, { params: page })
      .then((res) => res?.data?.data);
  }
  static async getAllFeatureInstructor() {
    return await api
      .get(`/${apiPrefix}/featureInstructor`)
      .then((res) => res?.data?.data);
  }

  static async getInstructorDetails(slug) {
    try {
      return await api
        .get(`/${apiPrefix}/instuctor/${slug}`)
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

  static async zoomCreate(formData) {
    return await api
      .post(`/${apiPrefix}/zoom/create`, formData)
      .then((res) => res?.data);
  }
  static async zoomSignature(formData) {
    return await api
      .post(`/${apiPrefix}/zoom-signature`, formData)
      .then((res) => res?.data);
  }

  static async getPayoutHistory(params) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/payout-history`, { params })

      .then((res) => res?.data?.data);
  }

  static async paymentConfrim(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/payout-confirm`, formData)
      .then((res) => res?.data);
  }


}

export default InstructorService;
